import { cmsAxios } from "./config/axiosConfig";

interface CreateCategoryPayload {
  courseName: string;
  courseDescription: string;
  fileId: string;
  categoryTypeId: string;
}

export const uploadFile = async (file: File | Blob, usingFor: string) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("usingFor", usingFor);

    const response = await cmsAxios.post("/cms/file/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error: any) {
    console.error("File upload failed:", error);
    throw error?.response?.data || error;
  }
};

// Get all category types
export const getAllCategoryTypes = async () => {
  try {
    const response = await cmsAxios.get("/cms/categories/list");
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch categories:", error);
    throw error?.response?.data || error;
  }
};

// Get all courses
export const getAllCategories = async () => {
  try {
    const response = await cmsAxios.get("/cms/courses/list");
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch courses:", error);
    throw error?.response?.data || error;
  }
};

export const createCategory = async (payload: CreateCategoryPayload) => {
  try {
    const response = await cmsAxios.post("/cms/courses/create", payload);
    return response.data;
  } catch (error: any) {
    console.error("Failed to create course:", error);
    throw error?.response?.data || error;
  }
};

interface UpdateCategoryePayload {
  courseName: string;
  courseDescription: string;
  fileId: string;
  categoryTypeId: string;
  isActive: boolean;
}

export const updateCourse = async (
  courseId: string,
  payload: UpdateCategoryePayload
) => {
  try {
    const response = await cmsAxios.put(`/cms/courses/${courseId}`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Course update failed:", error);
    throw error?.response?.data || error;
  }
};
